import moment from "moment";
import CheckNewCollectOrders from "../symbols/checkNewCollectOrders";

const initialState = {
  data: false,
  loading: false,
  error: false,
  timeStamp: moment().utc().format(),
  previousTimeStamp: false,
};

export default function CheckNewCollectOrdersReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case CheckNewCollectOrders.CHECK_NEW_COLLECT_ORDERS:
      return { ...state, loading: true, error: false };
    case CheckNewCollectOrders.CHECK_NEW_COLLECT_ORDERS_SUCCESS:
      const newTimeStamp = moment().utc().format();
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
        timeStamp: newTimeStamp,
        previousTimeStamp: action.payload.Result ? state.timeStamp : false,
      };
    case CheckNewCollectOrders.CHECK_NEW_COLLECT_ORDERS_FAILURE:
      return {
        ...state,
        data: false,
        loading: false,
        error: true,
      };
    case CheckNewCollectOrders.CHECK_NEW_COLLECT_ORDERS_REFRESH_TIME_STAMP:
      const newTime = moment().utc().format();
      return {
        ...state,
        timeStamp: newTime,
        previousTimeStamp: false,
      };
    case CheckNewCollectOrders.CLEAR_CHECK_NEW_COLLECT_ORDERS:
      return {
        ...state,
        data: false,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
